<template>
  <v-app id="inspire">
    <v-navigation-drawer app expand-on-hover permanent>
      <v-list-item class="pageTitle pa-2 orange lighten-2">
        <v-list-item-avatar>
          <v-img src="@/assets/img/myschedule2.png"></v-img>
        </v-list-item-avatar>

        <v-list-item-title class="text-h5">MySchedule</v-list-item-title>

        <v-dialog v-model="dialog" width="500" v-if="!this.isStudent()">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-apps</v-icon>
            </v-btn>
          </template>

          <v-card>
            <v-card-title class="text-h5 blue lighten-3">
              MySchool Systems
            </v-card-title>

            <v-card-text>
              <v-container fluid>
                <v-row>
                  <v-col
                    v-for="app in appItems"
                    :key="app.id"
                    cols="12"
                    md="6"
                    sm="6"
                    lg="6"
                  >
                    <v-list-item
                      link
                      :href="'https://' + app.subDomain + domain"
                      class="pa-2 orange lighten-2"
                    >
                      <v-list-item-avatar>
                        <v-img
                          :src="require(`@/assets/img/` + app.img)"
                        ></v-img>
                      </v-list-item-avatar>

                      <v-list-item-title class="text-h7">
                        {{
                          app.text
                        }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                text
                @click="$store.commit('logout'), (dialog = false)"
              >
                Logout
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-list-item>
      <v-divider></v-divider>

      <v-list-item class="px-2">
        <v-list-item-avatar>
          <v-img src="@/assets/img/robothead.jpg"></v-img>
        </v-list-item-avatar>

        <v-list-item-title>{{ UserName }}</v-list-item-title>

        <v-btn icon @click="$store.commit('logout')">
          <v-icon>mdi-logout</v-icon>
        </v-btn>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense>
        <v-list-item
          v-for="item in navItemsFiltered"
          :key="item.title"
          :href="item.route"
          link
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <!-- Sizes your content based upon application components -->
    <v-main>
      <!-- Provides the application the proper gutter -->
      <v-container fluid>
        <!-- If using vue-router -->
        <router-view></router-view>
      </v-container>
    </v-main>

    <v-footer app>
      <!-- -->
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    dialog: false,
    navItems: [],
    appItems: [
      {
        img: "wholeclass.png",
        icon: "mdi-comment-multiple-outline",
        text: "Students",
        subDomain: "students",
      },
      {
        img: "communication2.png",
        icon: "mdi-comment-multiple-outline",
        text: "Communications",
        subDomain: "communications",
      },
      {
        img: "myoffice1.png",
        icon: "mdi-comment-multiple-outline",
        text: "MyOffice",
        subDomain: "myschedule-office",
      },
      {
        img: "myschedule2.png",
        icon: "mdi-comment-multiple-outline",
        text: "MySchedule",
        subDomain: "myschedule",
      },
      {
        img: "hr1.png",
        icon: "mdi-comment-multiple-outline",
        text: "HR",
        subDomain: "hr",
      },
    ],
  }),
  computed: {
    domain() {
      let parts = process.env.VUE_APP_API_URL.split(".");
      return "." + parts[1] + "." + parts[2];
    },
    navItemsFiltered() {
      return this.navItems.filter((item) => item.permission === true);
    },
    UserImgSrc() {
      return this.$store.state.u.portrait_img;
    },
    UserName() {
      return this.$store.state.u.full_name;
    },
  },
  mounted() {
    this.navItems = [
      {
        title: "Dashboard",
        route: "dashboard",
        icon: "mdi-chart-line",
        permission: !this.isStudent(),
      },
      {
        title: "My Schedule",
        route: "my-schedule",
        icon: "mdi-calendar",
        permission: true,
      },
      {
        title: "My Lesson Plans",
        route: "lesson-plan-book",
        icon: "mdi-book",
        permission: !this.isStudent(),
      },
      {
        title: "My Grade Books",
        route: "gradebooks",
        icon: "mdi-table-edit",
        permission: true,
      },
      {
        title: "My Attendance",
        route: "attendance",
        icon: "mdi-human-male-board",
        permission: this.isStudent(),
      },
      {
        title: "My Students",
        route: "students",
        icon: "mdi-account-group",
        permission: !this.isStudent(),
      },
      {
        title: "My Discipline",
        route: "discipline",
        icon: "mdi-shield",
        permission: true,
        // this.can(["discipline-view-all"]),
      },
      {
        title: "Permissions",
        route: "permissions",
        icon: "mdi-cog",
        permission: this.isSystemAdmin(),
      },
      {
        title: "Help Desk",
        route: "helpdesk",
        icon: "mdi-lifebuoy",
        permission: true,
      },
    ];
  },
};
</script>
